module.exports = __webpack_public_path__ + "static/img/international-certification.6b787673.png";